<template>
<div>
    <b-navbar shadow type="is-primary" class="no-print">
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">

                <img src="/static/logo_itm.png" width="auto" alt="ITM Group Of Institutions">
                    &ensp; ITM Group Of Institutions
            </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <a class="button is-primary" href="https://itm.edu/institute-of-hotel-management">
                        <strong>Enquire Now</strong>
                    </a>
                    <a class="button is-primary" href="https://itmug.nopaperforms.com/ihm">
                        Apply Now
                    </a>
                    <a class="button is-light" href="/">
                       Log Out
                    </a>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
    <div class="container section">
        <div class="level">
            <!-- Left side -->
            <div class="level-left">
                <div class="level-item">
                    <img src="/static/logo.jpeg" alt="Logo" width="150">
                </div>
            </div>
            <!-- Right side -->
            <div v-if="isMobile()" class="level-right">
                <div class="level-item">
                    <div class="is-family-monospace">ITM IHM Online Mock JEE Exam Result</div>
                </div>
            </div>
            <div v-else class="level-right">
                <div  class="level-item">
                    <div class="subtitle is-family-monospace">ITM IHM Online Mock JEE Exam Result</div>
                </div>
            </div>
        </div>

        <div ref="content">
            <!-- Main container -->
            <div v-if="isMobile()" style="margin-bottom:20px;">
                <strong>Name :</strong> {{this.details.firstname}} {{this.details.lastname}} <br>
                    <strong>Email Id :</strong> {{this.details.email}}

            </div>
            <div v-else style="margin-bottom:20px;">
                <div class="level">
                <!-- Left side -->
                <div class="level-left">
                    <div class="level-item">
                        <p class="subtitle is-6">
                            <strong>Name :</strong> {{this.details.firstname}} {{this.details.lastname}}
                        </p>
                    </div>
                </div>

                <!-- Right side -->
                <div class="level-right">
                    <div class="level-item">
                        <p class="subtitle is-6">
                            <strong>Email Id :</strong> {{this.details.email}}
                        </p>
                    </div>
                </div>
            </div>
            </div>
            
            <div class="table-container">
                <table class="table is-bordered is-fullwidth is-narrow">

                    <tr>
                        <th>
                        </th>
                        <th>
                            Numerical Ability & Analytical Aptitude
                        </th>
                        <th>
                            Reasoning & Logical Deduction
                        </th>
                        <th>
                            Aptitude for Service Sector
                        </th>
                        <th>
                            English Language
                        </th>
                        <th>
                            General Knowledge & Current Affair
                        </th>
                        <th>
                            Total
                        </th>
                    </tr>
                    <tr>
                        <th>
                            Total Questions
                        </th>
                        <td>
                            {{Math.round(this.details.section_one_dit.totalQ)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_two_dit.totalQ)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_three_dit.totalQ)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_four_dit.totalQ)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_five_dit.totalQ)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_total_dit.totalQ)}}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Attempted
                        </th>
                        <td>
                            {{Math.round(this.details.section_one_dit.Attempted)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_two_dit.Attempted)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_three_dit.Attempted)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_four_dit.Attempted)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_five_dit.Attempted)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_total_dit.Attempted)}}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Correct
                        </th>
                        <td>
                            {{Math.round(this.details.section_one_dit.correct)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_two_dit.correct)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_three_dit.correct)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_four_dit.correct)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_five_dit.correct)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_total_dit.correct)}}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Incorrect
                        </th>
                        <td>
                            {{Math.round(this.details.section_one_dit.incorrect)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_two_dit.incorrect)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_three_dit.incorrect)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_four_dit.incorrect)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_five_dit.incorrect)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_total_dit.incorrect)}}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Net Score
                        </th>
                        <td>
                            {{Math.round(this.details.section_one_dit.score)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_two_dit.score)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_three_dit.score)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_four_dit.score)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_five_dit.score)}}
                        </td>
                        <td>
                            {{Math.round(this.details.section_total_dit.score)}}
                        </td>
                    </tr>

                </table>
            </div>

        </div>

        <div style="margin-top:10px;" class="is-family-monospace">
            <center> ITM GROUP OF INSTITUTIONS © 2020 </center>
        </div>

        <div class="column print-btn is-narrow no-print">
            <div class="has-text-right">

                <div class="button is-primary" @click="print"><i class="fa fa-print icon" style="color:white" title="Print Result"></i> &nbsp; Print</div>

            </div>
        </div>
    </div>

</div>
</template>

<script>
import Firebase from '../../lib/Firebase';
import Firestore from "../../lib/Firestore";
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import {
    bus
} from '../../main'
export default {
    name: 'Verify',
    data() {
        return {
            details: null,
            loading: true,
            final: {},
        }
    },
    mounted() {

    },
    computed: {

    },
    created() {
        this.fetchData();

        // console.log(this.data);
    },
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        createPDF() {
            let pdfName = 'test';
            var doc = new jsPDF();
            doc.text("Hello World", 10, 10);
            doc.save(pdfName + '.pdf');
        },
        download() {
            const doc = new jsPDF();
            const contentHtml = this.$refs.content.innerHTML;
            doc.fromHTML(contentHtml, 15, 15, {
                width: 170
            });
            doc.save("sample.pdf");
        },

        downloadWithCSS() {
            var vm = this;
            const doc = new jsPDF();
            /** WITH CSS */
            var canvasElement = document.createElement('canvas');
            html2canvas(this.$refs.content, {
                canvas: canvasElement
            }).then(function (canvas) {
                const img = canvas.toDataURL("image/jpeg", 0.3);
                doc.addImage(img, 'JPEG', 20, 20);
                doc.save(vm.details.candidateName);
            });
        },
        fetchData() {
            console.log("Param", this.$route.params.docId)
            Firebase.firestore().collection('report')
                .doc(this.$route.params.docId)
                // .doc(this.$route.params.certificateNo)
                .get()
                .then(docs => {

                    this.details = Firestore.getDocData(docs);
                    console.log(this.details);
                    this.final = {
                        ...this.details
                    }

                })
        },
        print() {
            window.print();
        }

    }
}
</script>

<style>
@media print {

    .no-print,
    .no-print * {
        display: none !important;
    }
}

@page {
    size: 30cm 40cm;
    margin: 0mm 20mm 0mm 20mm;
    /* change the margins as you want them to be. */
}



.login-container {
    background-color: #ffffff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.card {
    height: 100% !important;

}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/verify.vue